import CONSTANT from '../../constants'
import fetchWithAuthorizationHeader from '../../helper/fetchWithAuthorizationHeader'
import type { AccountApprovalRequest } from '../../types/account'

const { ACCOUNTS_API_URL } = CONSTANT

const acceptAccount = async (
	accountApproval: AccountApprovalRequest
): Promise<any> => {
	const response = await fetchWithAuthorizationHeader(`${ACCOUNTS_API_URL}`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			action: 'APPROVE'
		},
		body: JSON.stringify(accountApproval)
	})

	return response.json()
}

export default acceptAccount
